import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSessionHistory } from '../../services/sessionService';
import bg from '../../assets/bg-hero.jpg';
import { SessionList } from '../../components/common/SessionList';

export const BooksPage = () => {
  const navigate = useNavigate();
  const { userId } = useAuth();

  const {
    isLoading,
    sessions,
    error,
    hasMore,
    deletingSessions,
    deleteSession,
    loadMore,
    refetch,
    optimisticBumpSession,
  } = useSessionHistory(userId ? Number(userId) : 0, 1, 50, "b");

  return (
    <div
      className="h-screen bg-[#1a1a1a] bg-cover bg-center bg-no-repeat flex flex-col"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="flex flex-col w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8 flex-grow pb-20" style={{ height: 'calc(100vh - 56px)' }}>
        <div className="flex-shrink-0 space-y-4 sm:space-y-6 mt-16">


          <div className="text-center space-y-2">
            <h1 className="text-xl sm:text-2xl text-white font-bold">Books</h1>
            <p className="text-sm sm:text-base text-gray-300 font-montserrat font-medium">Master the world</p>
          </div>

          <div className="flex flex-col items-center space-y-1">
            <button
              onClick={() => navigate("/books/session")}
              className="bg-gradient-to-br from-[#79c9cb] to-[#4b7bdd] text-black py-2.5 sm:py-3 px-6 sm:px-8 rounded-3xl font-semibold hover:opacity-90 transition-opacity mb-1 text-sm sm:text-base"
            >
              New Book Summary
            </button>
            <div className="text-[10px] sm:text-xs text-gray-400 text-center">
              12 Book Summaries Remaining Until 5/15/25
            </div>
          </div>

          <div className="text-sm text-center">
            <p>Saved summaries:</p>
          </div>
        </div>

        <SessionList
          sessions={sessions?.data || null}
          isLoading={isLoading}
          error={error}
          hasMore={hasMore}
          deletingSessions={deletingSessions}
          deleteSession={deleteSession}
          loadMore={loadMore}
          sessionType="books"
          userId={userId || ''}
          emptyMessage="No book summaries found"
          refetchSessions={refetch}
          optimisticBumpSession={optimisticBumpSession}
        />
      </div>
    </div>
  );
};